import React, { useState, useEffect, useRef } from 'react';
import '../CreateProduct.css';
import { v4 as uuidv4 } from 'uuid'
import {
  Button,
  makeStyles, Paper,
  TableBody, TableRow, TableCell,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { createExtraMedicineDocument, getTodaySupplyOrderDocument, updateSupplyOrderDocument } from '../../../Backend/firebase/supply-order';
import { parseDate } from '../../Models/CommonFunc';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import CustomAlert from '../../CustomAlert';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px',
  },
}));

const headCells = [
  { id: 'id', label: 'Copy', disableSorting: false },
  { id: 'Particulars', label: 'Particulars', disableSorting: false },
  { id: 'Pack', label: 'Pack', disableSorting: false },
  { id: 'Company', label: 'Company', disableSorting: true },
  { id: 'HSN', label: 'HSN Code', disableSorting: true },
  { id: 'Batch', label: 'Batch No', disableSorting: false },
  { id: 'Exp', label: 'Expiry', disableSorting: false },
  { id: 'MRP', label: 'MRP', disableSorting: false },
  { id: 'Qty', label: 'Qty', disableSorting: false },
  { id: 'Scheme', label: 'Scheme', disableSorting: false },
  { id: 'Tax', label: 'Tax', disableSorting: false },
  { id: 'Discount', label: 'Discount', disableSorting: false },
  { id: 'Rate', label: 'Rate', disableSorting: false },
  { id: 'Amount', label: 'Amount', disableSorting: false },
  { id: 'Wholesaler', label: 'Wholesaler', disableSorting: false }
]

function MedicineBasedOnChemist() {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const [openNotify, setOpenNotify] = React.useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [alertType, setAlertType] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [TodayDate, setTodayDate] = useState(parseDate(new Date()));
  const [ChemistEntry, setChemistEntry] = useState([]);
  const [supplyOrderList, setSupplyOrderList] = useState([]);
  const [todayMedicineList, setTodayMedicineList] = useState([]);
  const [editedProductNames, setEditedProductNames] = useState({});
  const { userData } = CheckUserProvider();

  useEffect(async () => {
    if (userData) {
      try {
        setIsLoading(true);
        const getSupplyOrder = await getTodaySupplyOrderDocument();
        setSupplyOrderList(getSupplyOrder);

        const todaysMedicine = getSupplyOrder.filter(x =>
          parseDate(x.SupplyOrderPostedDateTime).includes(TodayDate)
        );
        setTodayMedicineList(todaysMedicine);
        setIsLoading(false);
      } catch (error) {
        console.log("Error Occur in Get Order", error);
        setIsLoading(false);
      }
    }
  }, [userData]);

  const handleTodayDateChange = (e) => {
    setTodayDate(parseDate(e.target.value));
    setIsLoading(true);
    const filterRecord = supplyOrderList?.filter(x =>
      parseDate(x.SupplyOrderPostedDateTime).includes(parseDate(e.target.value))
    );
    setTodayMedicineList(filterRecord);
    setChemistEntry([]);
    setIsLoading(false);
  };

  const onTapNextButton = async () => {
    setIsLoading(true);
    const filterRecord = supplyOrderList?.filter(x =>
      parseDate(x.SupplyOrderPostedDateTime).includes(TodayDate)
    );
    setTodayMedicineList(filterRecord);
    setChemistEntry([]);
    setIsLoading(false);
  };

  const handleOnSearch = (string, results) => {
    console.log('handleOnSearch', string, results)
    string?.length == 0 && setChemistEntry([]);
  }

  // Modify handleOnSelect to respect excludedItems
  const handleOnSelect = (item) => {
    const filteredItems = todayMedicineList?.filter(
      x =>
        x?.ProductName?.toLowerCase()?.includes(item?.ProductName?.toLowerCase()) &&
        !x.isSelected // Exclude already selected items
    );
    setChemistEntry(filteredItems);
  };

  const handleProductNameChange = (_id, newValue) => {
    setEditedProductNames(prev => ({
      ...prev,
      [_id]: newValue,
    }));
  };

  const handleSelectedItem = (_id) => {
    // Update the selected item's status in todayMedicineList
    const updatedMedicineList = todayMedicineList.map(item =>
      item._id === _id ? { ...item, isSelected: true } : item
    );
    setTodayMedicineList(updatedMedicineList);
    const updatedChemistEntry = ChemistEntry.filter(item => item._id !== _id);
    setChemistEntry(updatedChemistEntry);
    const selectedRecord = ChemistEntry.find(item => item._id === _id);
    const updatedProductName = editedProductNames[_id];
    if (!selectedRecord) {
      console.warn('No changes made or product name is empty');
      return;
    }

    try {
      const updatedRecord = {
        ...selectedRecord,
        ProductName: (updatedProductName && updatedProductName != null) ? updatedProductName : selectedRecord?.ProductName,
        ProductQuantity: selectedRecord?.ProductQuantity ? selectedRecord.ProductQuantity : '',
        ProductScheme: selectedRecord?.ProductScheme ? selectedRecord.ProductScheme : ''
      }
      const response = updateSupplyOrderDocument(updatedRecord);
      if (response) {
        console.info('Product name updated successfully in the database.');
      } else {
        console.log('Failed to update the product name in the database.');
      }
    } catch (error) {
      console.log('Error updating product name:', error);
    }

    //Added Extra Medicine 
    if(updatedProductName && updatedProductName != null) {
      var newMedicine = {};
      newMedicine.userId = userData.uid;
      newMedicine.ProductName = updatedProductName;
      try {
        var createdMedicine = createExtraMedicineDocument(newMedicine);
        if (createdMedicine) {
          console.log('Extra Medicine Added Successfully');
        } else {
          console.log('Extra Medicine Not Added Successfully');
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const formatResult = (item) => {
    return (
      <>
        <span style={{ display: 'block', textAlign: 'left' }}>
          {item.ProductName}
        </span>
      </>
    );
  };

  return (
    <>
      <div className="createProduct mt-2">
        {isLoading && <div className="loader-container">
          <div className="loader"></div>
        </div>}
        <Helmet>
          <meta name="description" content="Creating New Product And Sales page." />
          <title>Medicine List | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-12">
              <h5 className="mt-3 text-center">Medicine for Chemist &nbsp; </h5>
              <div className="row mb-3">
                <div className="col-md-8 mb-2">
                  <ReactSearchAutocomplete
                    items={todayMedicineList} // Filter excluded items
                    // items={todayMedicineList.filter(item => !excludedItems.includes(item._id))} // Filter excluded items
                    placeholder="Search Medicine..."
                    fuseOptions={{ keys: ['ProductName'] }}
                    resultStringKeyName="ProductName"
                    onSearch={handleOnSearch}
                    onSelect={handleOnSelect}
                    autoFocus
                    formatResult={formatResult}
                    styling={{
                      borderRadius: '8px',
                      zIndex: 1000,
                    }}
                    onClear={() => {
                      setChemistEntry([])
                    }}
                  />
                </div>
                <div className="col-md-3 mb-2">
                  <span className="form-control registerEmp__textbox registerEmp__datePicker">
                    <DatePickerComponent
                      id="TodayDate"
                      name="TodayDate"
                      value={TodayDate}
                      cssclassName="e-outline"
                      onChange={(e) => handleTodayDateChange(e)}
                      format="dd/MM/yyyy"
                      cleared={() => setTodayDate('')}
                    />
                  </span>
                </div>
                <div className="col-md-1 mb-2 mt-1">
                  <div className="addBox">
                    <Button
                      onClick={onTapNextButton}
                      variant="contained"
                      className="registerEmp__btnLogin jsmAdd"
                    >
                      {'Next'}
                    </Button>
                  </div>
                </div>
              </div>

              {ChemistEntry?.length > 0 && (
                <div className="row mb-3 ml-5 table-overflow">
                  <h6>Search Result:</h6>
                  <table className="table">
                    <thead>
                      <tr>
                        <td><b>Chemist Info</b></td>
                        <td><b>Product Name</b></td>
                        <td><b>Quantity</b></td>
                        <td><b>Scheme</b></td>
                        <td><b>Action</b></td>
                      </tr>
                    </thead>
                    <tbody>
                      {ChemistEntry.map((chemist, index) => {

                          const handleInputChange = (key, value) => {
                            const updatedItems = [...ChemistEntry];
                            updatedItems[index][key] = value;
                            setChemistEntry(updatedItems);
                          };
                        return (
                          <tr key={chemist._id}>
                            <td>{chemist?.ChemistInfo}</td>
                            <td>
                              <input
                                type="text"
                                value={chemist?.ProductName}
                                onChange={e => {
                                  handleInputChange("ProductName", e.target.value)
                                  handleProductNameChange(chemist._id, e.target.value)
                                }}
                              />
                            </td>
                            <td>
                              <input
                                className="smallInput"
                                type="text"
                                value={chemist?.ProductQuantity}
                                onChange={(e) => handleInputChange("ProductQuantity", e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="smallInput"
                                type="text"
                                value={chemist?.ProductScheme}
                                onChange={(e) => handleInputChange("ProductScheme", e.target.value)}
                              />
                            </td>
                            <td className="deleteCursor markSelectedWidth">
                              <Button
                                onClick={() => handleSelectedItem(chemist._id)}
                                variant="contained"
                                className="markSelected"
                                style={{ backgroundColor: 'red !important' }} >
                                {'Selected'}
                              </Button>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </Paper>
      </div>
      <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
          notificationMessage={notificationMessage} verticalPosition="top" horizontalPosition="right" />
    </>
  );
}

export default MedicineBasedOnChemist;

